import { render, staticRenderFns } from "./optionMobile.vue?vue&type=template&id=66b8800b"
import script from "./optionMobile.vue?vue&type=script&lang=js"
export * from "./optionMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports